import React from "react";
import { HiMail, HiPhone, HiCalendar, HiLocationMarker } from "react-icons/hi";
import toast from "react-hot-toast";
import { errorLogApi } from "../../../components/shared/GlobalState";

const ViewSubscriberModal = ({
  isOpen,
  onClose,
  selectedUser,
  getUserTypeBadgeColor,
}) => {
  if (!isOpen || !selectedUser) return null;

  return (
    <div className="fixed inset-0 z-50 overflow-y-auto">
      <div className="flex items-center justify-center min-h-screen px-4 pt-4 pb-20 text-center sm:block sm:p-0">
        <div className="fixed inset-0 transition-opacity" aria-hidden="true">
          <div className="absolute inset-0 bg-gray-500 opacity-75"></div>
        </div>

        <span
          className="hidden sm:inline-block sm:align-middle sm:h-screen"
          aria-hidden="true"
        >
          &#8203;
        </span>

        <div className="inline-block overflow-hidden text-left align-bottom transition-all transform bg-white rounded-lg shadow-xl sm:my-8 sm:align-middle sm:max-w-lg sm:w-full">
          <div className="px-4 pt-5 pb-4 bg-white sm:p-6 sm:pb-4">
            {/* User Basic Info */}
            <div className="sm:flex sm:items-start">
              <div className="flex items-center justify-center flex-shrink-0 w-12 h-12 mx-auto bg-indigo-100 rounded-full sm:mx-0 sm:h-10 sm:w-10">
                <span className="text-lg font-medium text-indigo-600">
                  {selectedUser.first_name?.[0]}
                  {selectedUser.last_name?.[0]}
                </span>
              </div>
              <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
                <h3 className="text-lg font-medium leading-6 text-gray-900">
                  {selectedUser.first_name} {selectedUser.last_name}
                </h3>
                <div className="mt-2">
                  <span
                    className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${getUserTypeBadgeColor(
                      selectedUser.user_type
                    )}`}
                  >
                    {selectedUser.user_type}
                  </span>
                  {selectedUser.role && (
                    <span className="inline-flex items-center px-2.5 py-0.5 ml-2 rounded-full text-xs font-medium bg-gray-100 text-gray-800">
                      {selectedUser.role}
                    </span>
                  )}
                </div>
              </div>
            </div>

            {/* Contact Information */}
            <div className="mt-6 space-y-4">
              <div className="flex items-center">
                <HiMail className="w-5 h-5 text-gray-400" />
                <span className="ml-2 text-sm text-gray-600">
                  {selectedUser.email || "No email provided"}
                </span>
              </div>
              <div className="flex items-center">
                <HiPhone className="w-5 h-5 text-gray-400" />
                <span className="ml-2 text-sm text-gray-600">
                  {selectedUser.mobile || "No phone provided"}
                </span>
              </div>
              <div className="flex items-center">
                <HiCalendar className="w-5 h-5 text-gray-400" />
                <span className="ml-2 text-sm text-gray-600">
                  Joined:{" "}
                  {new Date(selectedUser.createdAt).toLocaleDateString()}
                </span>
              </div>
              {selectedUser.address && (
                <div className="flex items-center">
                  <HiLocationMarker className="w-5 h-5 text-gray-400" />
                  <span className="ml-2 text-sm text-gray-600">
                    {selectedUser.address}
                  </span>
                </div>
              )}
            </div>

            {/* Family Information */}
            {selectedUser.user_type === "Sub Member" && (
              <div className="pt-6 mt-6 border-t border-gray-200">
                <h4 className="text-sm font-medium text-gray-900">
                  Family Information
                </h4>
                {selectedUser.familyDetails ? (
                  <div className="mt-4 space-y-4">
                    <div>
                      <span className="text-sm font-medium text-gray-500">
                        Family Name:
                      </span>
                      <span className="ml-2 text-sm text-gray-900">
                        {selectedUser.familyDetails.family_name}
                      </span>
                    </div>
                    <div>
                      <span className="text-sm font-medium text-gray-500">
                        Head of Family:
                      </span>
                      <span className="ml-2 text-sm text-gray-900">
                        {
                          selectedUser.familyDetails.primary_member_id
                            ?.first_name
                        }{" "}
                        {
                          selectedUser.familyDetails.primary_member_id
                            ?.last_name
                        }
                      </span>
                    </div>
                    {selectedUser.familyDetails.address && (
                      <div>
                        <span className="text-sm font-medium text-gray-500">
                          Family Address:
                        </span>
                        <span className="ml-2 text-sm text-gray-900">
                          {selectedUser.familyDetails.address}
                        </span>
                      </div>
                    )}
                    {selectedUser.familyDetails.city && (
                      <div>
                        <span className="text-sm font-medium text-gray-500">
                          City:
                        </span>
                        <span className="ml-2 text-sm text-gray-900">
                          {selectedUser.familyDetails.city}
                        </span>
                      </div>
                    )}
                  </div>
                ) : (
                  <div className="mt-4 text-sm text-gray-500">
                    No family details available
                  </div>
                )}
              </div>
            )}
          </div>
          <div className="px-4 py-3 bg-gray-50 sm:px-6 sm:flex sm:flex-row-reverse">
            <button
              type="button"
              className="inline-flex justify-center w-full px-4 py-2 text-base font-medium text-white bg-indigo-600 border border-transparent rounded-md shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:ml-3 sm:w-auto sm:text-sm"
              onClick={onClose}
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewSubscriberModal;
